import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@/components/errorBoundary';
import { BarcodeIssuesContent } from './BarcodeIssuesContent';
import type { BarcodeIssuesProps } from './useBarcodeIssues';

/**
 * The Products page's Barcode issues tab (bos-app#239) as a section of its
 * own (rulebook §5.2, §12; review of #241, finding 10): its list states are
 * its own, and the boundary keeps a render crash here from taking the
 * catalog tab with it. Its Try again renders the section again, and it
 * resets by itself when the branch changes.
 */
export const BarcodeIssues: React.FC<BarcodeIssuesProps> = ({
    branchId,
    isEnabled,
}) => {
    const { t } = useTranslation('pages');

    return (
        <ErrorBoundary
            data-testid="barcode-issues-boundary"
            fallbackMessage={t('products.barcodeIssues.crashed.message')}
            id="barcode-issues-boundary"
            resetKeys={[branchId]}
            retryLabel={t('products.barcodeIssues.loadError.retry')}
            title={t('products.barcodeIssues.crashed.title')}
        >
            <BarcodeIssuesContent branchId={branchId} isEnabled={isEnabled} />
        </ErrorBoundary>
    );
};
